// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResetNewPassword_resetNewPasswordContainer__aFWdD {
  max-width: 400px;
  margin: 50px auto;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
}

.ResetNewPassword_title__TM7Km {
  font-size: 24px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin-bottom: 20px;
}

.ResetNewPassword_subtitle__uDSUO {
  font-size: 16px;
  color: #555555;
  text-align: center;
  margin-bottom: 20px;
}

.ResetNewPassword_form__vU3xm {
  display: flex;
  flex-direction: column;
}

.ResetNewPassword_inputGroup__riLyF {
  margin-bottom: 15px;
}

.ResetNewPassword_label__N5VcG {
  font-size: 14px;
  color: #333333;
  margin-bottom: 5px;
  display: block;
  font-weight: 500;
}

.ResetNewPassword_input__yFbI9 {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  color: #333333;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.ResetNewPassword_input__yFbI9:focus {
  border-color: #0066cc;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 102, 204, 0.5);
}

.ResetNewPassword_submitButton__m6D9g {
  padding: 12px;
  font-size: 16px;
  color: #ffffff;
  background-color: #0066cc;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.3s ease;
  margin-top: 10px;
}

.ResetNewPassword_submitButton__m6D9g:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.ResetNewPassword_submitButton__m6D9g:hover:not(:disabled) {
  background-color: #005bb5;
}

.ResetNewPassword_successMessage__5mM18 {
  font-size: 14px;
  margin-top: 20px;
  text-align: center;
  color: #28a745;
}

.ResetNewPassword_errorMessage__IV16g {
  font-size: 14px;
  margin-top: 20px;
  text-align: center;
  color: #dc3545;
}`, "",{"version":3,"sources":["webpack://./src/Component/ResetNewPassword.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".resetNewPasswordContainer {\n  max-width: 400px;\n  margin: 50px auto;\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  font-family: Arial, sans-serif;\n}\n\n.title {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333333;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.subtitle {\n  font-size: 16px;\n  color: #555555;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n}\n\n.inputGroup {\n  margin-bottom: 15px;\n}\n\n.label {\n  font-size: 14px;\n  color: #333333;\n  margin-bottom: 5px;\n  display: block;\n  font-weight: 500;\n}\n\n.input {\n  width: 100%;\n  padding: 10px;\n  font-size: 14px;\n  color: #333333;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.input:focus {\n  border-color: #0066cc;\n  outline: none;\n  box-shadow: 0 0 5px rgba(0, 102, 204, 0.5);\n}\n\n.submitButton {\n  padding: 12px;\n  font-size: 16px;\n  color: #ffffff;\n  background-color: #0066cc;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  text-align: center;\n  transition: background-color 0.3s ease;\n  margin-top: 10px;\n}\n\n.submitButton:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.submitButton:hover:not(:disabled) {\n  background-color: #005bb5;\n}\n\n.successMessage {\n  font-size: 14px;\n  margin-top: 20px;\n  text-align: center;\n  color: #28a745;\n}\n\n.errorMessage {\n  font-size: 14px;\n  margin-top: 20px;\n  text-align: center;\n  color: #dc3545;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resetNewPasswordContainer": `ResetNewPassword_resetNewPasswordContainer__aFWdD`,
	"title": `ResetNewPassword_title__TM7Km`,
	"subtitle": `ResetNewPassword_subtitle__uDSUO`,
	"form": `ResetNewPassword_form__vU3xm`,
	"inputGroup": `ResetNewPassword_inputGroup__riLyF`,
	"label": `ResetNewPassword_label__N5VcG`,
	"input": `ResetNewPassword_input__yFbI9`,
	"submitButton": `ResetNewPassword_submitButton__m6D9g`,
	"successMessage": `ResetNewPassword_successMessage__5mM18`,
	"errorMessage": `ResetNewPassword_errorMessage__IV16g`
};
export default ___CSS_LOADER_EXPORT___;
